export class DateUtil{
 static convertUTCtoLocal(utcTime: string | undefined | Date): Date | undefined {
    if (!utcTime) {
      return undefined;
    }
    const utcDate = new Date(utcTime);
    return new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
  }
}
